/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RuleMutingV2Dto = {
    mutedUntil?: number;
    mutingMode: RuleMutingV2Dto.mutingMode;
};

export namespace RuleMutingV2Dto {

    export enum mutingMode {
        INDEFINITE = 'INDEFINITE',
        UNTIL_DATE = 'UNTIL_DATE',
        UNTIL_NEXT_STATUS_IMPROVES = 'UNTIL_NEXT_STATUS_IMPROVES',
        NOT_MUTED = 'NOT_MUTED',
    }


}
